import { genericRoute } from 'utils/routeUtils';

import DartsHomePage from './containers/DartsHomePage';
import DartsNav from './nav/DartsNav';

export default genericRoute(DartsHomePage, DartsNav, 'darts');



// WEBPACK FOOTER //
// ./modules/Darts/routes.js